/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./optional-group-item.vue?vue&type=template&id=ab340d06&scoped=true&"
import script from "./optional-group-item.vue?vue&type=script&lang=js&"
export * from "./optional-group-item.vue?vue&type=script&lang=js&"
import style0 from "./optional-group-item.vue?vue&type=style&index=0&id=ab340d06&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab340d06",
  null
  
)

export default component.exports